<template>

		<div class="reveal FR">
      <!-- <div class="running-total" style="position: fixed; top:10px; left:10px; z-index:9999;">{{yomoData.isUrban ? 'Urban' : 'Rural' }} Running Total: ${{runningTotal}}</div> -->
			<div class="slides">

          <!-- Welcome Slide -->
          <section data-background-color="#CDD8DF" data-background-image="/images/start_FRE@2x.png">

          </section>

          <!-- Region Slide -->
          <section data-background-color="#13294F">
            <h2 class="text-yellow uppercase font-weight-bold translatable" data style="max-width:950px; margin:0 auto;">CHOISIS LA RÉGION OÙ TU COMPTES T’INSTALLER APRÈS TES ÉTUDES. </h2>
            <p  style="color: #A89DFA;" class="funny mb-5 ">Avance vers ta nouvelle vie, tu vas adorer!</p>
            <table>
              <tr>
                <td class="text-center border-0">
                  <img data-src="/images/ChooseYourRegion_SmallCity@2x.png" class="border-0 bg-transparent" style="box-shadow:none;">
                  <button class="btn-primary btn-block" style="background: #3D4791; border: 1px solid #13294F; color: #fff; font-size: 1.2rem;" @click.prevent="updateRegion(false)">Petite ville/Milieu rural	</button></td>
                <td class="text-center border-0">
                  <img data-src="/images/ChooseYourRegion_LargeCity@2x.png" class="border-0 bg-transparent" style="box-shadow:none;">
                  <button class="btn-primary btn-block" style="background: #3D4791; border: 1px solid #13294F; color: #fff; font-size: 1.2rem;" @click.prevent="updateRegion(true)">Grande ville/Milieu urbain</button></td>
              </tr>
            </table>
          </section>

          <!-- Occupation Slide -->
          <section data-background-color="#E6E7E9">
            <h2 style="color: #13294F;">CHOISIS UN<br/>DOMAINE D’EMPLOI.</h2>
            <table class="no-border">
              <tr>
                <td>
                    <button class="btn-purple btn-block btn" @click.prevent="updateOccupation(occupations[0])">{{occupations[0].name}}</button>
                </td>
                <td>
                    <button class="btn-purple btn-block btn"  @click.prevent="updateOccupation(occupations[1])">{{occupations[1].name}}</button>
                </td>
              </tr>
              <tr>
                <td>
                    <button class="btn-purple btn-block btn"  @click.prevent="updateOccupation(occupations[2])">{{occupations[2].name}}</button>
                </td>
                <td>
                    <button class="btn-purple btn-block btn" @click.prevent="updateOccupation(occupations[3])">{{occupations[3].name}}</button>
                </td>
              </tr>
              <tr>
                <td>
                    <button class="btn-purple btn-block btn" @click.prevent="updateOccupation(occupations[4])">{{occupations[4].name}}</button>
                </td>
                <td>
                    <button class="btn-purple btn-block btn "  @click.prevent="updateOccupation(occupations[5])">{{occupations[5].name}}</button>
                </td>
              </tr>
              <tr>
                <td>
                    <button class="btn-purple btn-block btn"  @click.prevent="updateOccupation(occupations[6])">{{occupations[6].name}}</button>
                </td>
                <td>
                    <button class="btn-purple btn-block btn" @click.prevent="updateOccupation(occupations[7])">{{occupations[7].name}}</button>
                </td>
              </tr>
              <tr>
                <td>
                    <button class="btn-purple btn-block btn" @click.prevent="updateOccupation(occupations[8])">{{occupations[8].name}}</button>
                </td>
                <td>
                    <button class="btn-purple btn-block btn"  @click.prevent="updateOccupation(occupations[9])">{{occupations[9].name}}</button>
                </td>
              </tr>
              <tr>
                <td>
                    <button class="btn-purple btn-block btn"  @click.prevent="updateOccupation(occupations[10])">{{occupations[10].name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Occuptaion Selected Slide -->
          <section data-background-color="#E6E7E9"  :data-background-image="yomoData.occupation.background">
            <p class="text-red funny mb-5 mw-500" v-if="yomoData.occupation">{{yomoData.occupation.funny}}</p>
            <h1 class="text-purple occupation-title" v-if="yomoData.occupation">{{yomoData.occupation.name}}</h1>
            <p class="starting-income-text" v-if="yomoData.occupation">SALAIRE DE DÉPART</p>
            <h3 class="text-steel txt-lg" v-if="yomoData.occupation" >{{yomoData.isUrban ? yomoData.occupation.income.urban.toLocaleString('fr-FR') : yomoData.occupation.income.rural.toLocaleString('fr-FR') }} $</h3>
          </section>

          <!-- Expenses Start Slide -->
          <section  data-background-color="#E6E7E9" data-background-image="/images/expenses-rural_FRE@2x.png">

          </section>

          <!-- Housing Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-green">LOGEMENT</h2>
            <p class="text-red funny">Bienvenue chez vous!</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.housing.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-green btn-block btn"  @click.prevent="updateExpense('housing', index)">
                      <i v-if="yomoData.expenses.housing.buttons[index].active" class="animated fas fa-check"></i>
                    {{button.name}}
                  </button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Transportation Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-sky-blue">TRANSPORT</h2>
            <p class="text-red funny mw-500 mb-5">Le transport en commun pour réduire l’empreinte carbone.</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.transportation.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-sky-blue btn-block btn"  @click.prevent="updateExpense('transportation', index)"><i v-if="yomoData.expenses.transportation.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Food Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-yellow">NOURRITURE</h2>
            <p class="text-red funny mw-500 mb-5">Du Kraft Dinner... encore?</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.food.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-yellow btn-block btn"  @click.prevent="updateExpense('food', index)"><i v-if="yomoData.expenses.food.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Clothing Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-pink">VÊTEMENTS</h2>
            <p class="text-red funny mw-500 mb-5">Faut bien suivre la mode... mais sans accumuler des dettes!</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.clothing.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-pink btn-block btn"  @click.prevent="updateExpense('clothing', index)"><i v-if="yomoData.expenses.clothing.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Utilities Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-grey">SERVICES PUBLICS</h2>
            <p class="text-red funny mw-500 mb-5">Rester branché est important... mais ça coûte!</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.utilities.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-grey btn-block btn"  @click.prevent="updateExpense('utilities', index)"><i v-if="yomoData.expenses.utilities.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Entertainment Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-lime-green">DIVERTISSEMENT</h2>
            <p class="text-red funny mw-500 mb-5">Sais-tu que le taux d’abandon des abonnements aux gyms est d’environ 80 %?</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.entertainment.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-lime-green btn-block btn"  @click.prevent="updateExpense('entertainment', index)"><i v-if="yomoData.expenses.entertainment.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Personal Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-orange">FRAIS PERSONNELS</h2>
            <p class="text-red funny mw-500 mb-5">Offre-toi une belle coupe de cheveux!</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.personal.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-orange btn-block btn"  @click.prevent="updateExpense('personal', index)"><i v-if="yomoData.expenses.personal.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Education Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-grey-blue">REMBOURSEMENT DU PRÊT ÉTUDIANT</h2>
            <p class="text-red funny mw-500 mb-2">Savoir c’est pouvoir... mais faut payer!</p>
            <p class="mb-3" style="  font-style: italic !important;">Estimation des versements mensuels</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.education.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-grey-blue btn-block btn"  @click.prevent="updateExpense('education', index)"><i v-if="yomoData.expenses.education.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Education Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-brown">AUTRE</h2>
            <p class="text-red funny mw-500 mb-5">Sissi a-t-elle vraiment besoin de son traitement de beauté canine?</p>
            <table class="no-border">
              <tr v-for="(button, index) in yomoData.expenses.other.buttons" v-bind:key="button.id">
                <td>
                  <button class="btn-brown btn-block btn"  @click.prevent="updateExpense('other', index)"><i v-if="yomoData.expenses.other.buttons[index].active" class="fas fa-check"></i> {{button.name}}</button>
                </td>
              </tr>
            </table>
          </section>

          <!-- Education Expenses -->
          <section  data-background-color="#E6E7E9" >
            <h2 class="text-pumpkin">DÉPENSES MANQUANTES</h2>
            <p class="text-red funny mw-500 mb-5">Nooon... y a encore?</p>
            <p class="">Saisis ici toutes les dépenses non mentionnées avant :</p>
            <table class="no-border">
              <tr>
                <td>
                  <input type="number" v-model="yomoData.extraExpenses" class="input input-pumpkin">
                </td>
              </tr>
            </table>
          </section>

          <!-- Hit me with reality slide -->
          <section  data-background-color="#13294F" data-background-image="/images/ok-hit-me-rural_FRE@2x.png">

          </section>

          <!-- Totals Slide -->
          <section  data-background-color="#13294F" data-background-image="/images/2x/total-rural@2x.jpg">
            <h2 class="text-white">RÉSULTATS</h2>
            <table class="no-border">
              <tr>
                <td>
                  <p class="text-white opacity-70">REVENU</p>
                </td>
                <td>
                  <h2 class="text-green">{{  Number(yomoData.isUrban ? yomoData.occupation.income.urban : yomoData.occupation.income.rural).toLocaleString('fr-FR') + ' $'}}</h2>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="text-white opacity-70">DÉPENSES</p>
                </td>
                <td>
                  <h2 class="text-pumpkin">{{ runningTotal.toLocaleString('fr-FR') + ' $'}}</h2>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="text-white opacity-70">ÉPARGNE</p>
                </td>
                <td>
                  <h2 class="text-white">{{ (Number(yomoData.isUrban ? yomoData.occupation.income.urban : yomoData.occupation.income.rural) - Number(runningTotal)).toLocaleString('fr-FR') + ' $' }}</h2>
                </td>
              </tr>
            </table>
                  <p v-if="(Number(yomoData.isUrban ? yomoData.occupation.income.urban : yomoData.occupation.income.rural) - Number(runningTotal)) > 0" class="text-white opacity-70 text-center d-block w-100">Ouf! Ce n’est pas si pire...</p>
                  <p v-if="(Number(yomoData.isUrban ? yomoData.occupation.income.urban : yomoData.occupation.income.rural) - Number(runningTotal)) == 0" class="text-white opacity-70 text-center d-block w-100">Talk about breaking even!</p>
                  <p v-if="(Number(yomoData.isUrban ? yomoData.occupation.income.urban : yomoData.occupation.income.rural) - Number(runningTotal)) < 0" class="text-white opacity-70 text-center d-block w-100">Oups! Je suis dans le trouble...</p>
            <button class="btn-yellow btn"  @click.prevent="goToSlide(0)">RETOUR AU DÉBUT</button>
          </section>

			</div>
		</div>

</template>

<script>

import Reveal from 'reveal.js';

export default {
  name: 'app',
  components: {},
  mounted: function(){

    this.preloadImages();

    Reveal.initialize({
      controls: true,
      center: true,
      controlsLayout: 'edges',
      keyboard: true,
      slideNumber: true,
    });

    var self = this;
    Reveal.addEventListener( 'slidechanged', function( event ) {
      // event.previousSlide, event.currentSlide, event.indexh, event.indexv
      // refresh bg image for slide 3 because its dynamic in vue
      if(event.indexh == 3){
        setTimeout(function(){
          self.revealSync();
        }, 0);
      }
    });
  },
  computed: {
    runningTotal: function () {
        var housing = this.yomoData.expenses.housing.amount;
        var transportation = this.yomoData.expenses.transportation.amount;
        var food = this.yomoData.expenses.food.amount;
        var clothing = this.yomoData.expenses.clothing.amount;
        var utilities = this.yomoData.expenses.utilities.amount;
        var entertainment = this.yomoData.expenses.entertainment.amount;
        var personal = this.yomoData.expenses.personal.amount;
        var education = this.yomoData.expenses.education.amount;
        var other = this.yomoData.expenses.other.amount;
        var missing = this.yomoData.extraExpenses;
        return Number(housing + transportation + food + clothing + utilities + entertainment + personal + education + other) + Number(missing);
    }
  },
  methods: {
    preloadImages(){
      this.occupations.forEach(function(occupation){
          var img = new Image();
          img.src = occupation.background;
      });
    },
    goToSlide(number){
      Reveal.slide(number);
    },
    updateRunningTotal(){
      // TODO
      var urban = this.yomoData.isUrban;
      Object.values(this.yomoData.expenses).forEach(function (expense) {
        expense.amount = 0;
        if(expense.buttons == undefined){
          console.log('this exp is undefined: ' + expense.amount);
        }
        if(expense.buttons != undefined){
          expense.buttons.forEach(function(button){
            if(button.active == true){
              if(urban){
                expense.amount = expense.amount + button.urbanAmount;
              }else{
                expense.amount = expense.amount + button.ruralAmount;
              }
            }
          })
        }
      });
    },
    revealSync(){
      Reveal.sync()
    },
    nextSlide: function(){
      Reveal.next();
    },
    updateOccupation(occupation){
      this.yomoData.occupation = occupation;
      Reveal.next();
    },
    updateRegion(isUrban){
      this.yomoData.isUrban = isUrban;
      this.updateRunningTotal();
      Reveal.next();
    },
    updateExpense(type, buttonIndex){
      var amount = 0;

      switch(type){
        case 'housing':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.housing.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.housing.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.housing)){
            this.yomoData.expenses.housing.amount += amount;
          }else{
            if(this.yomoData.expenses.housing.amount != 0){
              this.yomoData.expenses.housing.amount -= amount;
            }
          }
        break;
        case 'transportation':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.transportation.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.transportation.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.transportation)){
            this.yomoData.expenses.transportation.amount += amount;
          }else{
            if(this.yomoData.expenses.transportation.amount != 0){
              this.yomoData.expenses.transportation.amount -= amount;
            }
          }
        break;
        case 'food':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.food.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.food.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.food)){
            this.yomoData.expenses.food.amount += amount;
          }else{
            if(this.yomoData.expenses.food.amount != 0){
              this.yomoData.expenses.food.amount -= amount;
            }
          }
        break;
        case 'clothing':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.clothing.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.clothing.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.clothing)){
            this.yomoData.expenses.clothing.amount += amount;
          }else{
            if(this.yomoData.expenses.clothing.amount != 0){
              this.yomoData.expenses.clothing.amount -= amount;
            }
          }
        break;
        case 'utilities':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.utilities.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.utilities.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.utilities)){
            this.yomoData.expenses.utilities.amount += amount;
          }else{
            if(this.yomoData.expenses.utilities.amount != 0){
              this.yomoData.expenses.utilities.amount -= amount;
            }
          }
        break;
        case 'entertainment':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.entertainment.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.entertainment.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.entertainment)){
            this.yomoData.expenses.entertainment.amount += amount;
          }else{
            if(this.yomoData.expenses.entertainment.amount != 0){
              this.yomoData.expenses.entertainment.amount -= amount;
            }
          }
        break;
        case 'personal':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.personal.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.personal.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.personal)){
            this.yomoData.expenses.personal.amount += amount;
          }else{
            if(this.yomoData.expenses.personal.amount != 0){
              this.yomoData.expenses.personal.amount -= amount;
            }
          }
        break;
        case 'education':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.education.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.education.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.education)){
            this.yomoData.expenses.education.amount += amount;
          }else{
            if(this.yomoData.expenses.education.amount != 0){
              this.yomoData.expenses.education.amount -= amount;
            }
          }
        break;
        case 'other':
          amount = this.yomoData.isUrban ? this.yomoData.expenses.other.buttons[buttonIndex].urbanAmount : this.yomoData.expenses.other.buttons[buttonIndex].ruralAmount;
          if(this.toggleButton(buttonIndex, this.yomoData.expenses.other)){
            this.yomoData.expenses.other.amount += amount;
          }else{
            if(this.yomoData.expenses.other.amount != 0){
              this.yomoData.expenses.other.amount -= amount;
            }
          }
        break;
        case 'missing':
          this.yomoData.extraExpenses = amount;
        break;
      }
      // Reveal.next();
    },
    toggleButton(buttonIndex, category){
      var status = false;
      if(category.buttons[buttonIndex].active){
        category.buttons[buttonIndex].active = false;
        status = false;
      } else {
        category.buttons[buttonIndex].active= true;
        status = true;
      }
      return status;
    }
  },
  data: function () {
    return {
      yomoData: {
        isUrban: true,
        extraExpenses: 0,
        expenses: {
          housing: {
            id: 1,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 170,
                ruralAmount: 172,
                name: "En famille",
              },
              {
                id: 2,
                active: false,
                urbanAmount: 1040,
                ruralAmount: 597,
                name: "Appartement 3½"
              },
              {
                id: 3,
                active: false,
                urbanAmount: 586,
                ruralAmount: 373,
                name: "Avec coloc. dans un 4½"
              }
            ]
          },
          transportation: {
            id: 2,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 777,
                ruralAmount: 740,
                name: "Nouvelle voiture"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 485,
                ruralAmount: 457,
                name: "Voiture usagée"
              },
              {
                id: 3,
                active: false,
                urbanAmount: 120,
                ruralAmount: 80,
                name: "Transport partagé (Uber, Netlift)"
              },
              {
                id: 4,
                active: false,
                urbanAmount: 109,
                ruralAmount: 65,
                name: "Transport en commun"
              }
            ]
          },
          food: {
            id: 3,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 219,
                ruralAmount: 225,
                name: "Épicerie (cuisiner)"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 186,
                ruralAmount: 150,
                name: "Restaurant (sortir)"
              },
              {
                id: 3,
                active: false,
                urbanAmount: 200,
                ruralAmount: 150,
                name: "Livraison de repas"
              }
            ]
          },
          clothing: {
            id: 4,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 43,
                ruralAmount: 42,
                name: "Magasiner un peu"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 175,
                ruralAmount: 75,
                name: "Magasiner beaucoup"
              }
            ]
          },
          utilities: {
            id: 5,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 50,
                ruralAmount: 50,
                name: "Hydro et chauffage"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 110,
                ruralAmount: 110,
                name: "Cellulaire"
              },
              {
                id: 3,
                active: false,
                urbanAmount: 35,
                ruralAmount: 35,
                name: "Internet"
              }
            ]
          },
          entertainment: {
            id: 6,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 175,
                ruralAmount: 170,
                name: "Câble de base, films, jeux, applis "
              },
              {
                id: 2,
                active: false,
                urbanAmount: 110,
                ruralAmount: 110,
                name: "Concerts, sorties, etc."
              },
              {
                id: 3,
                active: false,
                urbanAmount: 100,
                ruralAmount: 100,
                name: "Voyages d’aventure"
              },
              {
                id: 4,
                active: false,
                urbanAmount: 40,
                ruralAmount: 40,
                name: "Services de diffusion (Netflix, Amazon Prime Video, Crave TV)"
              },
              {
                id: 5,
                active: false,
                urbanAmount: 85,
                ruralAmount: 78,
                name: "Frais pour activités sportives / équipement / abonnement au gym"
              }
            ]
          },
          personal: {
            id: 7,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 45,
                ruralAmount: 45,
                name: "Soins personnels (articles de toilette, soins des ongles, coupe de cheveux)"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 35,
                ruralAmount: 35,
                name: "Lessive, nettoyage à sec"
              }
            ]
          },
          education: {
            id: 8,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 0,
                ruralAmount: 0,
                name: "0 $"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 300,
                ruralAmount: 300,
                name: "300 $"
              },
              {
                id: 3,
                active: false,
                urbanAmount: 400,
                ruralAmount: 400,
                name: "400 $"
              },
              {
                id: 4,
                active: false,
                urbanAmount: 500,
                ruralAmount: 500,
                name: "500 $"
              },
              {
                id: 5,
                active: false,
                urbanAmount: 600,
                ruralAmount: 600,
                name: "600 $"
              }
            ]
          },
          other: {
            id: 9,
            amount: 0,
            buttons: [
              {
                id: 1,
                active: false,
                urbanAmount: 30,
                ruralAmount: 30,
                name: "Cadeaux et dons de charité"
              },
              {
                id: 2,
                active: false,
                urbanAmount: 30,
                ruralAmount: 30,
                name: "Animal de compagnie"
              },
              {
                id: 3,
                active: false,
                urbanAmount: 50,
                ruralAmount: 50,
                name: "Divers"
              }
            ]
          }
        },
        occupation: {
            id: 1,
            name: 'Restauration',
            funny: 'Excellent choix! Les brunchs seront toujours populaires...',
            income: {
                rural: 1788,
                urban: 1788,
            },
        },
      },
      occupations: [
          {
            id: 1,
            name: 'Restauration',
            background: '/images/2x/Occupations/food-service@2x.jpg',
            funny: 'Excellent choix! Les brunchs seront toujours populaires...',
            income: {
              rural: 1850,
              urban: 1850,
            }
          },
          {
            id: 2,
            name: 'Vente et services à la clientèle',
            background: '/images/2x/Occupations/retail-customer-service@2x.jpg',
            funny: 'Tu es très sociable et ça se voit! Profite bien de ces qualités...',
            income: {
              rural: 2523,
              urban: 2523,
            }
          },
          {
            id: 3,
            name: 'Cosmétologie',
            background: '/images/2x/Occupations/cosmetology@2x.jpg',
            funny: 'L’industrie cosmétique affiche une croissance annuelle de 4,5 %. Bravo!',
            income: {
              rural: 1897,
              urban: 1897,
            }
          },
          {
            id: 4,
            name: 'Métiers qualifiés',
            background: '/images/2x/Occupations/skilled-trades@2x.jpg',
            funny: 'Les ouvriers qualifiés seront toujours en demande... Et avoir ces compétences aide à sauver de l’argent!',
            income: {
              rural: 4625,
              urban: 4625,
            }
          },
          {
            id: 5,
            name: 'Informatique',
            background: '/images/2x/Occupations/information-technology@2x.jpg',
            funny: 'À l’ère du numérique, tu ne manqueras jamais de travail. Place à la popularité des geeks!',
            income: {
              rural: 6273,
              urban: 6273,
            }
          },
          {
            id: 6,
            name: 'Médecine',
            background: '/images/2x/Occupations/medical-doctor@2x.jpg',
            funny: 'Sauver des vies tout en faisant de l’argent... le meilleur remède pour ta carrière!',
            income: {
              rural: 12825,
              urban: 12825,
            }
          },
          {
            id: 7,
            name: 'Enseignement',
            background: '/images/2x/Occupations/educational-services@2x.jpg',
            funny: 'C’est à ton tour de dire aux élèves de garder le silence et de suivre. Ton bon karma?',
            income: {
              rural: 4151,
              urban: 4151,
            }
          },
          {
            id: 8,
            name: 'Services financiers',
            background: '/images/2x/Occupations/financial-services@2x.jpg',
            funny: 'L’argent, source possible de problèmes? Pas si tu sais bien le gérer!',
            income: {
              rural: 6037,
              urban: 6037,
            }
          },
          {
            id: 9,
            name: 'Santé et services sociaux',
            background: '/images/2x/Occupations/health-human-services@2x.png',
            funny: 'Les compétences humaines et l’empathie sont en grande demande. Les robots ne peuvent pas faire un tel travail!',
            income: {
              rural: 7805,
              urban: 7805,
            }
          },
          {
            id: 10,
            name: 'Services de création',
            background: '/images/2x/Occupations/creative-services@2x.jpg',
            funny: 'Savais-tu que 95 % des gens créatifs sont vraiment hot?',
            income: {
              rural: 3868,
              urban: 3868,
            }
          },
          {
            id: 11,
            name: 'Services professionnels',
            background: '/images/2x/Occupations/professional-services@2x.jpg',
            funny: 'Le monde t’appartient!',
            income: {
              rural: 8624,
              urban: 8624,
            }
          }
      ]
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Homemade+Apple|Montserrat:400,600,800&display=swap');
@import url('./assets/css/reset.css');
@import url('./assets/css/reveal.css');
@import url('./assets/css/theme/white.css');
@import url('./../node_modules/aos/dist/aos.css');

// Text Stuff
h1,h2,h3,h4,h5,h6,p,td,button,a, div{
  font-family: 'Montserrat', sans-serif !important;
}
.funny{
  font-family: 'Homemade Apple', cursive !important;
  font-weight: normal !important;
  line-height: 1.9rem;
}
h1{
  font-size: 5rem !important;
  font-weight: 800 !important;
  line-height: 8rem !important;
}
h2{
  font-size: 3.5rem !important;
  line-height: 4.5rem !important;
  font-weight: 800 !important;
}
h3{
  font-size: 2rem !important;
}
p{
  font-size: 1.7rem !important;
}
// Colors
.text-red{
  color: #D13636 !important;
}
.text-pink{
  color: #E079FF !important;
}
.text-purple{
  color: #A89DFA !important;
}
.text-steel{
  color: #13294F !important;
}
.text-grey-blue{
  color: #8DABD5 !important;
}
.text-sky-blue{
  color: #3CB8E7 !important;
}
.text-orange{
  color: #F79B31 !important;
}
.text-blue{
  color: #234096 !important;
}
.text-lime-green{
  color: #A7CC46 !important;
}
.text-green{
  color: #74C5A2 !important;
}
.text-pumpkin{
  color: #EF5F2F !important;
}
.text-yellow{
  color: #FFBE31 !important;
}
.text-white{
  color: #fff !important;
}
.text-brown{
  color: #BCA8A1 !important;
}
.text-grey{
  color: #B9C5CC !important;
}
// Helpers
.mb-8{
  margin-bottom: 8rem !important;
}
.mb-7{
  margin-bottom: 7rem !important;
}
.mb-6{
  margin-bottom: 6rem !important;
}
.mb-5{
  margin-bottom: 5rem !important;
}

.mb-4{
  margin-bottom: 4rem !important;
}

.mb-3{
  margin-bottom: 3rem !important;
}

.mb-2{
  margin-bottom: 2rem !important;
}

.mb-1{
  margin-bottom: 1rem !important;
}
.mw-500{
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 500px !important;
}

.starting-income-text{
  font-weight: 600;
  color: #13294F;
  text-transform: uppercase;
  font-size: 1.2rem !important;
  margin:0 !important;
}
.txt-xl{
  font-size: 4rem !important;
}
.txt-lg{
  font-size: 3rem !important;
}
.txt-md{
  font-size: 2rem !important;
}
.txt-sm{
  font-size: 1rem !important;
}
.text-center{
  text-align: center;
}
.font-weight-bold{
  font-weight: 800 !important;
}
.uppercase{
  text-transform: uppercase;
}
.d-block{
  display: block !important;
}
.w-100{
  width: 100% !important;
}
.opacity-70{
  opacity: .7 !important;
}
.dark-border{
  -webkit-text-stroke: 3px #2B2E34 !important;
}
.border-0{
  border: 0 !important;
}
.bg-transparent{
  background: transparent !important;
}
table.no-border tr td{
  border:0 !important;
}
.occupation-title{
  max-width: 850px;
  margin: 0 auto !important;
  margin-bottom: 1rem !important;
}
// Buttons
.navigate-left .controls-arrow{
  transform: scale(2.2) rotate(0) !important;
}
.navigate-right .controls-arrow{
  transform: scale(2.2) rotate(180deg) !important;
}
.btn{
  font-family: 'Montserrat', sans-serif !important;
  font-weight: 600 !important;
  border-radius: 5px;
  padding:10px 20px;
  font-size: 1.3rem;
  color: #13294F;
  width: 440px !important;
  cursor: pointer;
  border:3px solid #13294F;
  transition: all .5s;
  i{
    display: inline-block;
  }
}
.btn-pink{
  background: #E079FF;
}
.btn-yellow{
  background: #FDC215;
}
.btn-orange{
  background: #F79B31;
}
.btn-brown{
  background: #BCA8A1;
}
.btn-pumpkin{
  background: #EF5F2F;
}
.btn-grey-blue{
  background: #8DABD5;
}
.btn-purple{
  background: #A89DFA;
}
.btn-green{
  background: #74C5A2 !important;
}
.btn-lime-green{
  background: #A7CC46 !important;
}
.btn-grey{
  background: #B9C5CC !important;
}
.btn-sky-blue{
  background: #3CB8E7 !important;
}
.btn-primary{
  background: #fff;
  color: #333;
  border-radius: 5px;
  font-weight: 600;
  padding:15px 20px;
  cursor: pointer;
  border:0;
  margin-right: 10px;
  display: block;
}
.btn-block{
  width: 100%;
  display: block;
}

input{
  color: #333;
  width: 100%;
  border-radius: 5px;
  padding:15px 20px;
  font-size: 1.7rem !important;
  font-weight: bold;
  font-family: 'Montserrat', sans-serif !important;
}
.input-pumpkin{
  background: #EF5F2F;
  border:2px solid #13294F;
}
.reveal{
  table{
    border:0;
    td{
      border:0;
      text-align: center;
    }
  }
}

button{
  &:focus{
    outline:none;
  }
}

.scrollable {
    bottom: 0px;
    overflow-y: auto  !important;
    overflow-x: hidden !important;
}

.navigate-left{
  left: 30px !important;
}
.navigate-right{
  right: 30px !important;
}
</style>
